import React  from 'react';
import { createRoot } from 'react-dom/client';
import CartView from "./CartView";
const container = document.getElementById('card_user');
const root = createRoot(container);
root.render(<React.StrictMode><CartView /></React.StrictMode>);